<template>
  <figure class="m-0 bg-light">
    <img class="w-100" :src="fileUrl(product.banner)" :alt="product.name" itemprop="image">
  </figure>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ProductBanner',
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      fileUrl: 'cdn/fileUrl'
    }),
    imageSize () {
      return 100
    },
  }
}
</script>
